import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class GoodsReceivingService extends ApiService {
  namespace = "goods-receiving";
  icon = "PalletizedBoxes";
  name = "Type";
  favicon = "CubeBlue";
  Width = 1400;
  DOMAIN = DOMAIN.GOODS_RECEIVING;
  action = "action";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;
  constructor() {
    super("goods-receiving");
  }
}
